import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "row full-width justify-center items-center q-pa-md" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = ["href"]

import { ref } from 'vue';
import { useI18n } from 'vue-i18n';


export default /*#__PURE__*/_defineComponent({
  __name: 'Footer',
  props: ['imprintUrl'],
  setup(__props) {

const { t, locale } = useI18n();
const { imprintUrl } = __props;

return (_ctx: any,_cache: any) => {
  const _component_q_footer = _resolveComponent("q-footer")!

  return (_openBlock(), _createBlock(_component_q_footer, {
    elevated: "",
    class: "bg-secondary text-white q-pt-md q-mt-lg"
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        (__props.imprintUrl)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _createElementVNode("a", {
                class: "text-white q-pa-sm",
                href: __props.imprintUrl,
                target: "_blank"
              }, _toDisplayString(_ctx.$t('message.legalNoticeFLbl')), 9, _hoisted_3)
            ]))
          : _createCommentVNode("", true)
      ])
    ]),
    _: 1
  }))
}
}

})